module.exports = __webpack_public_path__ + "static/media/whatsapp-b.0a5b4b39.svg";